import React from 'react';
import PropTypes from 'prop-types';
import {
  ChartLine,
  Percent,
  PhoneCall,
  Smiley,
} from '@phosphor-icons/react';
import AnalyticsStatCard from '../../components/AnalyticsStatCard';
import COLORS from '../../util/constants/colors';

const formatPercent = (value) => (value === null || value === undefined ? 'N/A' : value);
const formatSentiment = (value) => (value === null || value === undefined ? 'N/A' : value);
const abandonRateSubtitle = (abandonRate) => {
  const count = abandonRate?.count || 0;
  const denominator = abandonRate?.denominator || 0;

  return denominator > 0 ? `${count} of ${denominator} classified calls` : 'No classified calls';
};

const MairaStats = ({ analyticsData, loading }) => {
  const total = analyticsData.call_volume?.total || 0;
  const abandonRate = analyticsData.incomplete_abandon_rate;
  const abandonRatePercentage = abandonRate?.percentage;
  const averageSentiment = analyticsData.sentiment?.average;
  const classifiedCount = analyticsData.outcomes?.classified_count || 0;
  const unclassifiedCount = analyticsData.outcomes?.unclassified_count || 0;
  const coverageDenominator = classifiedCount + unclassifiedCount;
  const coveragePercentage = coverageDenominator > 0
    ? Math.round((classifiedCount / coverageDenominator) * 100)
    : null;

  return (
    <div className="analytics-stats maira-stats">
      <AnalyticsStatCard
        label="Total Calls"
        value={total}
        valueColor={COLORS.BLUE_PRIMARY_LITE}
        icon={<PhoneCall size={24} weight="bold" />}
        iconColor={COLORS.BLUE}
        loading={loading}
      />
      <AnalyticsStatCard
        label="Incomplete / Abandon"
        value={formatPercent(abandonRatePercentage)}
        valueColor={COLORS.ERROR_LITE}
        unit={abandonRatePercentage === null || abandonRatePercentage === undefined ? '' : '%'}
        subtitle={abandonRateSubtitle(abandonRate)}
        icon={<Percent size={24} weight="bold" />}
        iconColor={COLORS.ERROR_SECONDARY_LITE}
        loading={loading}
      />
      <AnalyticsStatCard
        label="Avg Sentiment"
        value={formatSentiment(averageSentiment)}
        valueColor={COLORS.SUCCESS_HOVER_LITE}
        icon={<Smiley size={24} weight="bold" />}
        iconColor={COLORS.SUCCESS_SECONDARY_DARK}
        loading={loading}
      />
      <AnalyticsStatCard
        label="Classification Coverage"
        value={formatPercent(coveragePercentage)}
        unit={coveragePercentage === null ? '' : '% classified'}
        subtitle={`${classifiedCount} classified / ${unclassifiedCount} unclassified`}
        valueColor={COLORS.PURPLE_PRIMARY_LITE}
        icon={<ChartLine size={24} weight="bold" />}
        iconColor={COLORS.PURPLE_TERTIARY_LITE}
        loading={loading}
      />
    </div>
  );
};

MairaStats.propTypes = {
  analyticsData: PropTypes.object,
  loading: PropTypes.bool,
};

MairaStats.defaultProps = {
  analyticsData: {},
  loading: false,
};

export default MairaStats;
